import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, page }) {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  if (page && user.role !== "admin") {
    const access = user.page_access || ["fascicoli"];
    if (!access.includes(page)) return <Navigate to="/" replace />;
  }
  return children;
}
